"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var components_utils_1 = require("@conte-ltd/components-utils");

function _Collapse(props, fwRef) {
  var children = props.children,
      isExpanded = props.isExpanded;

  var _a = (0, components_utils_1.useResizeObserver)(),
      ref = _a.ref,
      height = _a.height;

  var rendered = (0, components_utils_1.useRunIfFunction)(children, {
    ref: ref
  });
  return (0, jsx_runtime_1.jsx)("div", __assign({
    css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        overflow: hidden;\n        transition: var(\n          --c-collapse-transition,\n          var(--c-transition-duration-normal) var(--c-transition-timing-easein)\n        );\n        opacity: 0;\n\n        &[data-expanded] {\n          opacity: 1;\n        }\n      "], ["\n        overflow: hidden;\n        transition: var(\n          --c-collapse-transition,\n          var(--c-transition-duration-normal) var(--c-transition-timing-easein)\n        );\n        opacity: 0;\n\n        &[data-expanded] {\n          opacity: 1;\n        }\n      "]))),
    "data-expanded": isExpanded || undefined,
    ref: fwRef
  }, (0, components_utils_1.mergeProps)({
    style: isExpanded ? {
      height: height ? height + "px" : 'auto'
    } : {
      height: 0
    }
  }, (0, components_utils_1.styleProps)(props)), {
    children: rendered
  }), void 0);
}

exports.Collapse = (0, react_2.forwardRef)(_Collapse);
var templateObject_1;